module.exports = __webpack_public_path__ + "img/mda_ico_3.8f5a5057.svg";